import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { X, Loader2 } from 'lucide-react';
import { formatDate } from '../utils/date';
import { curLabel } from '../utils/currency';
import { useT } from '../utils/translate';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const fmt = n => Number(n || 0).toLocaleString('en-US', { maximumFractionDigits: 2 });

// Akt-sverka qatorini bosganda ochiladigan pastdan-chiquvchi karta —
// hujjat tarkibini (tovarlar) faqat shu bosilganda, on-demand yuklaydi.
export default function AktSverkaDocModal({ row, currency, onClose }) {
  const t = useT();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    axios.get(`${API}/client/akt-sverka/doc/${row.kind}/${row._id}`)
      .then(res => { if (alive) setDoc(res.data.doc); })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [row]);

  const items = (doc?.items || []).filter(it => it && (it.name || it.qty || it.amount));

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white w-full sm:max-w-md sm:rounded-2xl rounded-t-2xl shadow-modal max-h-[85vh] flex flex-col safe-bottom">
        <div className="flex items-center justify-between px-4 py-3.5 border-b border-surface-100 shrink-0">
          <div className="min-w-0">
            <p className="font-semibold text-ink truncate">{row.kindLabel} №{row.number}</p>
            <p className="text-xs text-ink-tertiary">{formatDate(row.date)}</p>
          </div>
          <button onClick={onClose} className="p-1.5 rounded-lg text-ink-tertiary hover:text-ink hover:bg-surface-100 transition-colors shrink-0 ml-2">
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          {loading ? (
            <div className="flex items-center justify-center py-10">
              <Loader2 className="w-5 h-5 animate-spin text-ink-tertiary" />
            </div>
          ) : items.length > 0 ? (
            <div className="divide-y divide-surface-100">
              {items.map((it, i) => (
                <div key={i} className="flex items-center justify-between gap-3 py-2 first:pt-0">
                  <div className="min-w-0">
                    <p className="text-sm text-ink truncate">{it.name || '—'}</p>
                    <p className="text-xs text-ink-tertiary mt-0.5">{fmt(it.qty)} {it.uom} × {fmt(it.price)}</p>
                  </div>
                  <p className="text-sm font-semibold text-ink shrink-0">{fmt(it.amount)}</p>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-ink-tertiary text-center py-6">{t('aktSverka.itemsEmpty')}</p>
          )}

          {doc?.note && <p className="text-sm text-ink-secondary mt-3">{doc.note}</p>}
        </div>

        <div className="flex items-center justify-between px-4 py-3.5 border-t border-surface-200 shrink-0">
          <span className="text-sm font-semibold text-ink">{t('aktSverka.total')}</span>
          <span className="text-base font-bold text-ink">{fmt(doc?.total)} {curLabel(doc?.currency || currency)}</span>
        </div>
      </div>
    </div>
  );
}
